// tslint:disable
export enum RegisterElement {
	category_bar = 'category_bar',
	search_bar = 'search_bar',
	top_banner = 'top_banner',
	top_icon = 'top_icon',
	module_view = 'module_view',
	rec_list_x = 'rec_list_x',
	home_enter_hijack = 'page_hijack',
	home_enter_normal = 'page',
	index_popwindow_pop = 'index_popwindow_pop',
	index_popwindow_click = 'index_popwindow_click',
	show_top_coupon = 'show_top_coupon',
	show_top_coupon_click = 'show_top_coupon_click',
	slideLecture_click = 'slideLecture_click'
}	



// WEBPACK FOOTER //
// ./src/services/hotspotReport.ts